import { combineReducers } from "redux";
import landingPages from "../tool/landing-page/landing-page-reducers.js";
import editerPick from "../tool/editer-pick/editer-pick-reducer.js";
import homepageTrending from "../tool/homepage-trending/homepage-trending-reducer.js";

const toolReducers = combineReducers({
    landingPages,
    editerPick,
    homepageTrending,
});

export default toolReducers;
